/**
 * 機能キーを持つユーザーにだけ子 (画面) を表示するルートガード (権限管理 SBI-6)。
 *
 * 持っていない場合は、許可された先頭の画面へリダイレクトする。許可された画面が 1 つも無ければ
 * 「権限がありません」を表示する。
 *
 * ⚠️ 画面の出し分けは利便性のため。最終的な拒否は常にバックエンドの 403。
 */
import { Navigate } from 'react-router';

import { usePermissions } from '../contexts/PermissionContext';
import { landingPath } from '../permissions/screens';

import { NoPermissionScreen } from './NoPermissionScreen';

interface RequireFeatureProps {
  featureKey: string;
  children: React.ReactNode;
}

export function RequireFeature({ featureKey, children }: RequireFeatureProps): React.JSX.Element {
  const { features, has } = usePermissions();
  if (has(featureKey)) {
    return <>{children}</>;
  }
  const landing = landingPath(features);
  return landing ? <Navigate to={landing} replace /> : <NoPermissionScreen />;
}
